import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TestAssignmentService {
  private readonly ASSESSMENT_BASE_URL = 'https://assessment.seqtechnology.com';

  constructor() {}

  getTestLink(uniqueCode: string): string {
    return `${this.ASSESSMENT_BASE_URL}/${uniqueCode}`;
  }

  copyTestLink(uniqueCode: string): void {
    const link = this.getTestLink(uniqueCode);
    navigator.clipboard.writeText(link);
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'pending': return 'badge-secondary';
      case 'in_progress': return 'badge-primary';
      case 'completed': return 'badge-success';
      case 'cancelled': return 'badge-danger';
      case 'expired': return 'badge-danger';
      default: return 'badge-secondary';
    }
  }

  getStatusDisplay(status: string): string {
    return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
}
